import * as allExports from "@react-aria/dialog";
const { useDialog } = allExports;
export { useDialog };
//# sourceMappingURL=main.entry.mjs.mjs.map